import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';

import { history } from 'util/history';

import AccountAddress from './AccountAddress';
import AccountFilter from './AccountFilter';
import Auth from './Auth';
import ClientDetail from './ClientDetail';
import Common from './Common';
import LoaderReducer from './LoaderReducer';
import Settings from './Settings';
import TabReducer from './TabIssueReducer/TabReducer';
import TermsDetail from './TermsDetail';
import User from './User';
import UserFilter from './UserFilter';
import DiamondReducer from './diamond';
import tableValues from './table-values';

const reducers = combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  commonData: Common,
  client: ClientDetail,
  tab: TabReducer,
  accountAddress: AccountAddress,
  user: User,
  accountFilter: AccountFilter,
  userFilter: UserFilter,
  termsDetail: TermsDetail,
  loader: LoaderReducer,

  tableValues,
  diamondData: DiamondReducer,
});

export default reducers;
